"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var ethereumjs_tx_1 = __importDefault(require("ethereumjs-tx"));
var utils_1 = require("ethers/utils");
var Trezor = (function (_super) {
    __extends(Trezor, _super);
    function Trezor() {
        var _this = _super.call(this) || this;
        _this.PATH_TYPE = {
            LIVE: "m/44'/60'/0'/0"
        };
        _this.PATH_TYPE_NAME = {
            LIVE: "Standard"
        };
        _this.cacheAddressCount = 3 * _this.PER_PAGE;
        _this.currentPathRule = _this.PATH_TYPE.LIVE;
        _this.currentPath = "m/44'/60'/0'/0/0";
        _this.masterNodes = {};
        var lastSelectedPathRule = window.localStorage.getItem("Trezor:lastSelectedPathRule");
        var lastSelectedPath = window.localStorage.getItem("Trezor:lastSelectedPath");
        if (lastSelectedPathRule && lastSelectedPath) {
            _this.setPath(lastSelectedPathRule, lastSelectedPath);
        }
        _this.TrezorConnector = require("trezor-connect").default;
        return _this;
    }
    Trezor.prototype.type = function () {
        return Trezor.TYPE;
    };
    Trezor.prototype.id = function () {
        return Trezor.TYPE;
    };
    Trezor.prototype.signPersonalMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (message.slice(0, 2) === "0x") {
                            message = message.slice(2);
                        }
                        else {
                            message = Buffer.from(message).toString("hex");
                        }
                        return [4, this.TrezorConnector.ethereumSignMessage({ path: this.currentPath, message: message, hex: true })];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            return [2, "0x" + res.payload.signature];
                        }
                        else {
                            throw new Error(res.payload.error);
                        }
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2];
                }
            });
        });
    };
    Trezor.prototype.signTransaction = function (txParams) {
        return __awaiter(this, void 0, void 0, function () {
            var networkID, currentAddress, nonce, tx, res, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4, this.loadNetworkId()];
                    case 1:
                        networkID = _a.sent();
                        if (!txParams.chainId) {
                            txParams.chainId = networkID;
                        }
                        if (!!txParams.nonce) return [3, 4];
                        return [4, this.getAddresses()];
                    case 2:
                        currentAddress = _a.sent();
                        return [4, _1.getTransactionCount(currentAddress[0], "pending")];
                    case 3:
                        nonce = _a.sent();
                        txParams.nonce = nonce;
                        _a.label = 4;
                    case 4:
                        txParams = this.formatTxParams(txParams);
                        tx = new ethereumjs_tx_1.default(txParams);
                        tx.raw[6] = Buffer.from([networkID]);
                        tx.raw[7] = Buffer.from([]);
                        tx.raw[8] = Buffer.from([]);
                        return [4, this.TrezorConnector.ethereumSignTransaction({ path: this.currentPath, transaction: txParams })];
                    case 5:
                        res = _a.sent();
                        tx.v = Buffer.from(res.payload.v.substr(2), "hex");
                        tx.r = Buffer.from(res.payload.r.substr(2), "hex");
                        tx.s = Buffer.from(res.payload.s.substr(2), "hex");
                        return [2, "0x" + tx.serialize().toString("hex")];
                    case 6:
                        e_2 = _a.sent();
                        throw e_2;
                    case 7: return [2];
                }
            });
        });
    };
    Trezor.prototype.sendTransaction = function (txParams) {
        return __awaiter(this, void 0, void 0, function () {
            var rawData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.signTransaction(txParams)];
                    case 1:
                        rawData = _a.sent();
                        return [2, _1.sendRawTransaction(rawData)];
                }
            });
        });
    };
    Trezor.prototype.getAddressesWithPath = function (pathRule, from, count) {
        return __awaiter(this, void 0, void 0, function () {
            var addresses, i, address, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        addresses = {};
                        i = from;
                        _a.label = 1;
                    case 1:
                        if (!(i < from + count)) return [3, 4];
                        return [4, this.deriveAddress(pathRule, i)];
                    case 2:
                        address = _a.sent();
                        addresses = __assign({}, addresses, address);
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3, 1];
                    case 4: return [2, addresses];
                    case 5:
                        e_3 = _a.sent();
                        throw e_3;
                    case 6: return [2];
                }
            });
        });
    };
    Trezor.prototype.getAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.addresses[this.currentPath]) return [3, 1];
                        return [2, [this.addresses[this.currentPath]]];
                    case 1:
                        _b = (_a = Object).values;
                        return [4, this.deriveAddress(this.currentPathRule, this.getCurrentPathIndex())];
                    case 2: return [2, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    Trezor.prototype.deriveAddress = function (pathRule, index) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.masterNodes[pathRule]) return [3, 2];
                        return [4, this.TrezorConnector.getPublicKey({ path: pathRule })];
                    case 1:
                        res = _b.sent();
                        if (res.success) {
                            this.connected = true;
                            this.masterNodes[pathRule] = utils_1.HDNode.fromExtendedKey(res.payload.xpub);
                        }
                        else {
                            this.connected = false;
                            throw new Error(res.payload.error);
                        }
                        _b.label = 2;
                    case 2: return [2, (_a = {},
                            _a[this.getPath(pathRule, index)] = this.masterNodes[pathRule].derivePath(index.toString()).address.toLowerCase(),
                            _a)];
                }
            });
        });
    };
    Trezor.prototype.getStartPageIndex = function (index) {
        return Math.max(Math.floor(index / this.cacheAddressCount) - this.PER_PAGE, 0);
    };
    Trezor.prototype.name = function () {
        return "Trezor";
    };
    Trezor.LABEL = "Trezor";
    Trezor.TYPE = "TREZOR";
    return Trezor;
}(_1.HardwareWallet));
exports.default = Trezor;
